import Navigation from "../../Components/Navbar";
import "./index.scss"
const Home = () => {     
    return(
        <div>
        <Navigation />
        <div className="tbody">
            <div className="container-lg">

            </div>
        </div>
        </div>
    )
};

export default Home;
